import React from 'react';

// Split string into word-spans, each containing char-spans.
// Preserves word-breaking and avoids dangling letters.
const SplitText = ({ text, className = '', charClassName = 'char inline-block' }) => {
    const words = text.split(' ');
    return (
        <span className={className}>
            {words.map((word, wi) => (
                <span key={wi} className="inline-block whitespace-nowrap">
                    {word.split('').map((c, ci) => (
                        <span key={ci} className={charClassName} style={{ display: 'inline-block' }}>
                            {c}
                        </span>
                    ))}
                    {wi < words.length - 1 && <span className="inline-block">&nbsp;</span>}
                </span>
            ))}
        </span>
    );
};

export default SplitText;
